<template>
    <fieldset class="order-details co-fieldset">
        <div class="co-fieldset-inner">
            <div class="od-inputs-row flex">
                <div class="program-input-grid-container">
                    <div class="program-input-grid-item">
                        <label class="co-select-input">
                            <div
                                class="co-label co-bold-label co-label-asterisk"
                            >
                                Program Name
                            </div>
                            <input
                                dusk="program-name-input"
                                type="text"
                                name="name"
                                class="create-program-form-input"
                                placeholder="Enter program name"
                                v-model="formState.name"
                            />
                        </label>
                    </div>
                    <div class="program-input-grid-item">
                        <label class="co-select-input">
                            <span class="co-label">Order Type
                            <span class="co-asterisk" v-if="options.order_type_required">*</span></span>
                            <v-select
                                dusk="order-details-type-component"
                                placeholder="Choose Type"
                                label="name"
                                height="40"
                                name="type"
                                v-model="formState.type"
                                class="co-custom-arrow"
                                :reduce="(type) => type.plunetid"
                                :options="options.types"
                            >
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes"
                                        ><chevron-down-icon :size="24"
                                    /></span>
                                </template>
                            </v-select>
                        </label>
                    </div>
                </div>
            </div>

            <div class="od-inputs-row">
                <div class="program-input-grid-container">
                    <div>
                        <label class="co-select-input">
                            <span class="co-label">Naming Convention for Orders</span>
                            <v-select
                                dusk="order-details-type-component"
                                placeholder="Leave Order name blank"
                                label="name"
                                height="40"
                                name="type"
                                v-model="formState.naming_convention"
                                class="co-custom-arrow"
                                :options="[
                                    'Leave Order name blank',
                                    'Timestamp + Program Name',
                                    'Program Name + Timestamp',
                                ]"
                            >
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes"
                                        ><chevron-down-icon :size="24"
                                    /></span>
                                </template>
                            </v-select>
                        </label>
                    </div>
                    <div>
                        <label class="co-select-input">
                            <span class="co-label">
                                Add PO Number to Program Orders
                                <span
                                    class="co-asterisk"
                                    v-if="options.po_required"
                                    >*</span
                                >
                            </span>
                            <multiselect
                                dusk="order-details-po-component"
                                placeholder="Select existing PO or enter new "
                                class="co-custom-arrow"
                                :taggable="true"
                                :multiple="true"
                                :options="options.order_numbers"
                                v-model="formState.purchase_order_numbers"
                                :tag-placeholder="'Press Enter to add a new PO'"
                                @tag="onPO"
                            />
                        </label>
                    </div>
                </div>
            </div>

            <div class="co-fieldset-inner">
                <label class="co-select-input">
                    <span class="co-label"
                        >Order Tags (type and click Enter to add)
                        <span class="co-asterisk" v-if="options.tag_required"
                            >*</span
                        ></span
                    >
                    <multiselect
                        dusk="order-details-tags-component"
                        v-model="formState.tags"
                        placeholder="Select tags or enter a new one"
                        name="tags"
                        class="co-custom-arrow"
                        :show-labels="false"
                        :option-height="80"
                        :options="detailsTags"
                        :multiple="true"
                        :taggable="true"
                        @tag="onTag"
                    >
                        <template #caret="{ toggle }">
                            <chevron-down-icon
                                :size="24"
                                @mousedown.prevent.stop="toggle()"
                                class="multiselect__select"
                            />
                        </template>
                        <span slot="noResult">No Tags found</span>
                    </multiselect>
                </label>
            </div>
        </div>
        <br />
        <div>
            <label>
                <span style="font-weight: 600">Program Description</span>
                <textarea
                    class="program-create-textarea"
                    name="description"
                    :class="{
                        'co-placeholder': !formState.description,
                        'co-bold-label': true,
                    }"
                    placeholder="Enter Program Description"
                    v-model="formState.description"
                    cols="100"
                    rows="5"
                />
            </label>
        </div>
    </fieldset>
</template>
<script>
import "./style.scss";
import { InformationOutlineIcon, ChevronDownIcon } from "../../icons.js";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";

export default {
    props: {
        options: {
            type: Object,
            required: true,
        },
    },
    methods: {
        ...mapActions("CreateProgramStore", [
            "updateOrderDetailsValue",
            "updateOrderName",
        ]),
        ...mapMutations("CreateProgramStore", [
            "setOrderName",
            "setNamingConvention",
            "setType",
            "setDescription",
            "setPurchaseOrderNumbers",
            "setTags",
        ]),

        getCurrentDate() {
            return moment().format("YYYY-MM-DD");
        },

        /**
         * Add a new tag
         *
         * @param string tag
         */
        onTag(tag) {
            if (this.detailsTags.indexOf(tag) < 0) {
                //add to tags options list
                this.options.tags.push({ label: tag, value: 9999 });

                //add tag to users order
                this.formState.tags.push(tag);
            }
        },

        /**
         * Add a new Po
         *
         * @param string po
         */
        onPO(po){
            if (this.options.order_numbers.indexOf(po) < 0) {
                //add to tags options list
                this.options.order_numbers.push(po);

                //add tag to users order
                this.formState.purchase_order_numbers.push(po);
            }
        }
    },

    computed: {
        ...mapState({
            formState: (state) => state.CreateProgramStore,
        }),
        ...mapGetters("AuthStore", ["isAdminUser"]),

        /**
         * An array of program names and id's
         *
         * @return array
         */
        programs() {
            let programs = this.options.programs;

            return Object.keys(programs).map((program) => {
                return { label: programs[program], value: program };
            });
        },

        /**
         * Get a list of tag names for 'order details' section
         *
         * @return array
         */
        detailsTags() {
            return this.options.tags.map((tag) => tag.label);
        },
    },
    components: {
        InformationOutlineIcon,
        ChevronDownIcon,
    },
};
</script>
